var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31,
    fill: "#EFEFEF",
    stroke: "#CDCDCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 38C43 38.5304 42.7893 39.0391 42.4142 39.4142C42.0391 39.7893 41.5304 40 41 40H23C22.4696 40 21.9609 39.7893 21.5858 39.4142C21.2107 39.0391 21 38.5304 21 38V27C21 26.4696 21.2107 25.9609 21.5858 25.5858C21.9609 25.2107 22.4696 25 23 25H27L29 22H35L37 25H41C41.5304 25 42.0391 25.2107 42.4142 25.5858C42.7893 25.9609 43 26.4696 43 27V38Z",
    stroke: "#424244",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36C34.2091 36 36 34.2091 36 32C36 29.7909 34.2091 28 32 28C29.7909 28 28 29.7909 28 32C28 34.2091 29.7909 36 32 36Z",
    stroke: "#424244",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIco);
export default __webpack_public_path__ + "static/media/cameraIco.52ecb069c4b75385644e2e35e36b8234.svg";
export { ForwardRef as ReactComponent };